/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import PageIllustration from "../partials/PageIllustration"
import { useLocation } from "@reach/router"

const NavLink = ({ children, to }) => (
  <li className="py-2 border-b border-gray-800">
    <Link
      className="flex items-center px-3 group text-gray-400 hover:text-purple-600 transition duration-150 ease-in-out"
      to={to}
    >
      <span>{children}</span>
      <svg
        className="w-3 h-3 fill-current flex-shrink-0 ml-2 opacity-0 group-hover:opacity-100 group-hover:text-purple-600 group-hover:translate-x-1 transition duration-150 ease-in-out transform"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z" />
      </svg>
    </Link>
  </li>
)

const ActiveLink = ({ children }) => (
  <li className="py-2 border-b border-gray-800">
    <div className="flex items-center px-3 group text-purple-600 hover:text-purple-600 transition duration-150 ease-in-out">
      <span>{children}</span>
    </div>
  </li>
)

const LegalPages = ({ children }) => {
  const path = useLocation().pathname

  return (
    <React.Fragment>
      <main className="flex-grow">
        {/*  Page illustration */}
        <div
          className="relative max-w-6xl mx-auto h-0 pointer-events-none"
          aria-hidden="true"
        >
          <PageIllustration />
        </div>

        {/*  Page sections */}
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
          <div className="pt-32 pb-12 md:pt-40 md:pb-20">
            <div className="flex flex-col md:flex-row">
              {/* Main content */}
              <main
                className="filmLegalPage md:flex-auto md:pl-10 order-1"
                data-aos="fade-up"
              >
                {children}
              </main>

              {/* Nav sidebar */}
              <aside className="md:w-64 mb-16 md:mb-0 md:mr-10 md:flex-shrink-0 h-44"></aside>
              <aside
                className="md:w-64 mb-16 md:mb-0 md:mr-10 md:flex-shrink-0 fixed "
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <h4 className="text-lg font-medium px-3 pb-3 border-b border-gray-800">
                  Legal
                </h4>
                <nav>
                  <ul>
                    {path === "/terms/" ? (
                      <ActiveLink>Terms of Service</ActiveLink>
                    ) : (
                      <NavLink to="/terms/">Terms of Service</NavLink>
                    )}
                    {path === "/privacy/" ? (
                      <ActiveLink>Privacy Policy</ActiveLink>
                    ) : (
                      <NavLink to="/privacy/">Privacy Policy</NavLink>
                    )}
                    {path === "/content-policy/" ? (
                      <ActiveLink>Content Policy</ActiveLink>
                    ) : (
                      <NavLink to="/content-policy/">Content Policy</NavLink>
                    )}
                    {path === "/cookie-policy/" ? (
                      <ActiveLink>Cookie Policy</ActiveLink>
                    ) : (
                      <NavLink to="/cookie-policy/">Cookie Policy</NavLink>
                    )}
                    {path === "/referral-program-agreement/" ? (
                      <ActiveLink>Referral Program Agreement</ActiveLink>
                    ) : (
                      <NavLink to="/referral-program-agreement/">
                        Referral Program Agreement
                      </NavLink>
                    )}
                  </ul>
                </nav>
              </aside>
            </div>
          </div>
        </div>
      </main>
    </React.Fragment>
  )
}

LegalPages.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LegalPages
